import { PropagandaModel } from 'model/api/gestao/propaganda/propaganda-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { VariaveisAmbiente } from 'config';



export function useGetPropagandaById() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<PropagandaModel>();

    const getPropagandaById = useCallback(
        (id: string) => invocarApi({
            url: `/v1/Propagandas/${id}/`,
            method: 'GET',
            enviarTokenUsuario: true,
            baseURL: VariaveisAmbiente.apiPropaganda + '/api',
        }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getPropagandaById,
    };
}
